import { CellProps } from 'react-table'
import { ImportacaoErro } from '../../core/_models'
import { useQueryRequest } from '../../core/QueryRequestProvider'
import { sortableColumn, StackedCell, TableColumn } from '../../../../../../components'

const importacoesErrosColumns: ReadonlyArray<TableColumn<ImportacaoErro>> = [
  sortableColumn<ImportacaoErro>({
    id: 'linha',
    cellWidth: '96px',
    useQueryRequest,
    fields: [{ field: 'linha', label: 'Linha' }],
    Cell: ({ row }: CellProps<ImportacaoErro>) => (
      <StackedCell tabular primary={row.original.linha?.toString()} />
    ),
  }),
  sortableColumn<ImportacaoErro>({
    id: 'campo',
    cellWidth: '220px',
    useQueryRequest,
    fields: [{ field: 'campo', label: 'Campo' }],
    Cell: ({ row }: CellProps<ImportacaoErro>) => <StackedCell primary={row.original.campo} />,
  }),
  // Mensagem de erro inteira (quebra linha): é o que a pessoa precisa ler para corrigir.
  sortableColumn<ImportacaoErro>({
    id: 'erro',
    useQueryRequest,
    fields: [{ field: 'erro', label: 'Erro' }],
    Cell: ({ row }: CellProps<ImportacaoErro>) => <span>{row.original.erro || '—'}</span>,
  }),
]

export { importacoesErrosColumns }
